export default __webpack_public_path__ + "static/coperta-campanii-sus-ef8b358fae652d0cd5dfa27fd2a74bea.jpg";